var TopicCacheEntry = require('routing/topic-cache-entry');

module.exports = function NoValueEntry(details, streams) {
    TopicCacheEntry.call(this, details, streams);

    this.handleValue = function(received, registry, errorHandler) {
        this.notifyValue(received, null, received, registry);
    };

    this.handleDelta = function(received, registry, errorHandler) {
        this.notifyDelta(received, null, null, received, registry);
    };

    this.notifyValueToNewStream = function(path, stream) {
        // No value
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/routing/topic-cache-no-value-entry.js
// module id = 1043
// module chunks = 1